import { Column } from "../Column";

// Two clusters hugging the pond's left and right banks.
const REEDS = [
  { left: "5%", height: "70%", delay: "0s" },
  { left: "8%", height: "92%", delay: "-0.7s" },
  { left: "11%", height: "62%", delay: "-1.4s" },
  { left: "89%", height: "78%", delay: "-2.1s" },
  { left: "93%", height: "58%", delay: "-2.8s" },
];

export const PlayyardPond = () => {
  /* Render */
  const render = () => {
    return (
      <Column
        className="pointer-events-none absolute left-[4%] top-[59%] z-[6] h-[12%] w-[27%] rounded-[50%] shadow-[inset_0_6px_12px_rgb(0_0_0_/_0.25)]"
        style={{
          // Water mirrors the sky palette from the scene root.
          background:
            "linear-gradient(var(--yard-waterTop), var(--yard-waterBottom))",
          outline:
            "5px solid color-mix(in srgb, var(--yard-groundBottom) 80%, black)",
        }}
      >
        <Column className="staffer-pet-yard-shimmer absolute left-[20%] top-[30%] h-[3px] w-[18%] rounded-full bg-white/55" />
        <Column className="staffer-pet-yard-shimmer absolute left-[55%] top-[55%] h-[3px] w-[24%] rounded-full bg-white/55 [animation-delay:-1.5s]" />
        <Column className="staffer-pet-yard-shimmer absolute left-[30%] top-[72%] h-[3px] w-[12%] rounded-full bg-white/55 [animation-delay:-2.5s]" />
        <Column className="absolute bottom-[17%] left-[26%] h-3 w-7 rounded-[50%] bg-[conic-gradient(from_20deg,#2f7d3a_0_320deg,transparent_320deg)]" />
        <Column className="absolute right-[18%] top-[24%] h-2.5 w-5 rounded-[50%] bg-[conic-gradient(from_200deg,#2f7d3a_0_320deg,transparent_320deg)]">
          <Column className="absolute -top-1 left-[35%] h-2 w-2 rounded-full bg-[radial-gradient(#fff6_0_30%,#ff9ec4_32%)]" />
        </Column>
      </Column>
    );
  };

  return render();
};

// Cattails at the pond's edge, swaying with the wind like the grass.
export const PlayyardPondPlants = () => {
  /* Render */
  const render = () => {
    return (
      <Column className="pointer-events-none absolute left-[2%] top-[49%] z-[11] h-[11%] w-[31%]">
        {REEDS.map((reed) => (
          <Column
            key={reed.left}
            className="staffer-pet-yard-sway absolute bottom-0 w-[3px] rounded-full bg-[#3d5a26]"
            style={{
              left: reed.left,
              height: reed.height,
              animationDelay: reed.delay,
            }}
          >
            <Column className="absolute -left-[2px] top-0 h-4 w-[7px] rounded-full bg-[#6b4323]" />
          </Column>
        ))}
      </Column>
    );
  };

  return render();
};
